/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RequestAuditProfileAutoTrigger extends models.RequestAuditBaseRequest {
    getFixupPrototypeFunction() { return RequestAuditProfileAutoTrigger.fixupPrototype; }

    static newInstance(model: Partial<RequestAuditProfileAutoTrigger>): RequestAuditProfileAutoTrigger {
        let obj = Object.assign(new RequestAuditProfileAutoTrigger(), model);
        RequestAuditProfileAutoTrigger.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RequestAuditProfileAutoTrigger>): RequestAuditProfileAutoTrigger {
        if (!model) return null;
        return RequestAuditProfileAutoTrigger.newInstance(<RequestAuditProfileAutoTrigger> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RequestAuditProfileAutoTrigger) {
        if (!obj) return;

        models.RequestAuditProfileAutoTrigger.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RequestAuditProfileAutoTrigger): boolean {
        if (models.RequestAuditBaseRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RequestAuditProfileAutoTrigger.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.activations === undefined) {
            this.activations = 0;
        }
        if (this.execution_time_threshold === undefined) {
            this.execution_time_threshold = 0;
        }
        if (this.backoff_time === undefined) {
            this.backoff_time = 0;
        }
    }

    /**
     * Number of activations for each auto trigger run.
     */
    activations: number;

    /**
     * Trigger profiling only for requests that take longer than this time.
     */
    execution_time_threshold: number;

    /**
     * Number of seconds to wait before re-enabling auto trigger.
     */
    backoff_time: number;

}
